import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const { t, i18n } = useTranslation('common');

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleLanguage = () => {
    const newLang = i18n.language === 'ko' ? 'en' : 'ko';
    i18n.changeLanguage(newLang);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-md shadow-lg'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <div className={`text-2xl font-bold transition-colors ${
              isScrolled ? 'text-[#1a2332]' : 'text-white'
            }`}>
              INSIDE <span className="text-[#14B8A6]">Global</span>
            </div>
          </div>

          <div className="hidden md:flex items-center space-x-8">
            <a
              href="#about"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-white hover:text-[#14B8A6]'
              }`}
            >
              {t('nav.about')}
            </a>
            <a
              href="#services"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-white hover:text-[#14B8A6]'
              }`}
            >
              {t('nav.services')}
            </a>
            <a
              href="#partnership"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-white hover:text-[#14B8A6]'
              }`}
            >
              {t('nav.partnership')}
            </a>
            <a
              href="#network"
              className={`text-base font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#14B8A6]' : 'text-white hover:text-[#14B8A6]'
              }`}
            >
              {t('nav.network')}
            </a>
          </div>

          <div className="flex items-center space-x-4">
            <button
              onClick={toggleLanguage}
              className={`px-4 py-2 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                isScrolled
                  ? 'text-gray-700 hover:bg-gray-100'
                  : 'text-white hover:bg-white/10'
              }`}
            >
              {i18n.language === 'ko' ? 'EN' : 'KO'}
            </button>
            <button className="bg-[#14B8A6] text-white px-6 py-2.5 rounded-full font-medium hover:bg-[#0d9488] transition-all flex items-center space-x-2 cursor-pointer whitespace-nowrap">
              <span>{t('nav.contact')}</span>
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
